<template>
  <section> 
   
    <div id="card-block" v-for="(data, index) in gameData" :key="index">
       <transition>
      <card-template
        :earning-rate="gameData[index].earningPerSec"
        :annual-profit="gameData[index].annualEarnings"
        :percent-change="gameData[index].percentChange"
        v-if="showGameCat(gameData[index].category)"
      >
        <template v-slot:image>
          <img
            class="game-logo"
            :src="getImgUrl(gameData[index].image)"
            v-bind:alt="gameData[index].image"
          />
        </template>
        <template v-slot:publisherName>
          {{ gameData[index].publisher }}
        </template>
      </card-template>
      </transition>
    </div>
   
  </section>
</template>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 20px 0px 0px 0px;
}

#card-block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

.game-logo {
  width: 150px;
  @include respond(phone-only) {
    width: 75px;
  }
}
.v-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.v-enter-to {
  opacity: 1;
  transform: translateX(0);
}
.v-enter-active {
  transition: all 0.8s ease-out;
}

</style>

<script>
import CardTemplate from "@/components/GameProfits/CardTemplate";
import data from "@/assets/data/GameData.js";
export default {
  data() {
    return {
      allData: data.gameData,
      gameData: [],
    };
  },
  components: {
    CardTemplate,
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/images/games/" + pic);
    },
    showGameCat(category) {
      if (this.$store.getters.getGameCat == "ALL") {
        return true;
      }
      if (category == this.$store.getters.getGameCat) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.gameData = this.allData;
  },
};
</script>